import { Group, ScrollArea, SimpleGrid } from '@mantine/core';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import RunCard from '@/pages/AutomationPage/components/RunCard.tsx';
import { RunWithDatasets } from '@/types/runs.ts';

type RunsCardsProps = {
  runs: RunWithDatasets[];
  hasNextPage: boolean;
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
};

const RunsCards = ({ runs, hasNextPage, fetchNextPage, isFetchingNextPage }: RunsCardsProps) => {
  return (
    <ScrollArea
      scrollbars={'y'}
      offsetScrollbars={'y'}
      mr={'-12px'}
      // style={{ position: 'relative' }}
    >
      <SimpleGrid
        cols={{ base: 1, xs: 1, sm: 2, md: 3, lg: 3, xl: 4 }} // responsive breakpoints
        mb="lg"
        spacing="lg"
        verticalSpacing={'xl'}
      >
        {runs.map((item) => (
          <RunCard key={item.run.id} runWithDatasets={item} />
        ))}
      </SimpleGrid>

      {hasNextPage && (
        <Group justify={'center'} w={'100%'} my={'xs'}>
          <StyledButton
            loading={isFetchingNextPage}
            onClick={() => fetchNextPage()}
            variant={'outline'}
            loaderProps={{ color: 'var(--velos-brand-pink)' }}
          >
            Load More
          </StyledButton>
        </Group>
      )}
    </ScrollArea>
  );
};

export default RunsCards;
